export default function WishlistsTitle() {
  return (
    <h1 className="text-left text-c32 font-semibold text-black222 mb-c28 mt-6">
      Wishlists
    </h1>
  );
}
